import React, { Suspense } from 'react';
import { PieChart } from 'react-minimal-pie-chart';

import {
  nervousSystemStates,
} from '../../constants/nervousSystemStates'

import {
  InfoSvg
} from '../../constants/svgs'

const blurredDataStyle = {filter: "blur(3px)", WebkitFilter: "blur(3px)"}

const Select = React.lazy(() => import('./SelectDropdown'));

const PieChartInsightSection = ({
  title,
  timeIntervalTitle,
  dataIsAvailable,
  data,
  blurData,
  fillColorData,
  insightText,
  insightTextFunction,
  firstName,
  dropDownOptions,
  dropDownIsOpen,
  onDropDownSelect,
  onToggleDropDown,
  disableDropDown,
  onLearnMoreButtonClick,
  dataCategories
}) => (
  <div style={{backgroundColor: "#CFD2DD", padding: "max(3vw, 16px)", marginTop: "min(3vw, 16px)", boxShadow: "0px 1px 1.5px 0.5px #dddddd"}}>
    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
      <div style={{width: !!(timeIntervalTitle) ? "80%" : "100%", fontFamily: "Futura Book", fontSize: "min(5vw, 22px)", lineHeight: "min(5vw, 22px)"}}>
        <Suspense fallback={
          <div style={{border: "none", padding: 0, height: "min(5vw, 22px)", fontSize: "min(5vw, 22px)", lineHeight: "min(5vw, 22px)", textAlign: "left", color: "#000000", fontFamily: "Futura Book"}}>
            {title}
          </div>
        }>
          <Select
            style={{border: "none", opacity: 1.0, borderColor: "transparent", padding: 0, boxShadow: "none", minHeight: "min(5vw, 22px)", fontSize: "min(5vw, 22px)", lineHeight: "min(5vw, 22px)", color: "#000000", fontFamily: "Futura Book"}}
            values={[{label: title, value: 0}]}
            disabled={disableDropDown}
            options={dropDownOptions}
            onChange={(values) => !!(onDropDownSelect) && onDropDownSelect(values[0].value)}
            onDropdownOpen={() => !!(onToggleDropDown) && onToggleDropDown(true)}
            onDropdownClose={() => !!(onToggleDropDown) && onToggleDropDown(false)}
            labelField={"label"}
            valueFields={"value"}
            color={"#000000"}
            contentRenderer={({state}) => (
              <div style={{border: "none", padding: 0, height: "min(5vw, 22px)", fontSize: "min(5vw, 22px)", lineHeight: "min(5vw, 22px)", textAlign: "left", color: dropDownIsOpen ? "#a3a8bd" : "#000000", fontFamily: "Futura Book"}}>
                {state.values[0].label}
              </div>
            )}
            dropdownHandleRenderer={() => (
              (!(disableDropDown) ? (
                <svg style={{height: "min(3vw, 14px)", width: "min(3vw, 14px)"}} width="725px" height="725px" viewBox="0 0 725 725" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Group-40" transform="translate(0.804489, 0.300000)"><rect id="Rectangle" x="0" y="0" width="724" height="724"></rect><g id="noun-chevron-152840" transform="translate(22.195511, 157.700000)" fill={dropDownIsOpen ? "#a3a8bd" : "#000000"} fillRule="nonzero"><path d="M291.99,388.1595 L19.93,116.0995 C6.645,102.8145 -5.68434189e-14,85.4195 -5.68434189e-14,68.0135 C-5.68434189e-14,50.6115 6.6445,33.2125 19.93,19.9275 C46.477,-6.6425 89.563,-6.6425 116.11,19.9275 L340.07,243.8875 L564.04,19.9275 C590.587,-6.6425 633.673,-6.6425 660.22,19.9275 C686.79,46.4975 686.79,89.5365 660.22,116.1075 L388.16,388.1675 C361.613,414.7295 318.523,414.7295 291.984,388.159688 L291.99,388.1595 Z" id="Path"></path></g></g></g></svg>
              ) : (
                <span style={{height: 0, width: 0, padding: 0, margin: 0}}></span>
              ))
            )}
            />
        </Suspense>
      </div>
      {!!(timeIntervalTitle) && (
        <div style={{width: "20%", textAlign: "right", minHeight: "min(3.5vw, 16px)", fontSize: "min(3.5vw, 16px)", fontFamily: "Futura Book"}}>
          {timeIntervalTitle}
        </div>
      )}
    </div>
    {(dataIsAvailable) ? (
      <div style={{marginTop: 10}}>
        <div style={blurData ? blurredDataStyle : {}}>
          <PieChart 
            data={(dataCategories || nervousSystemStates).map(k => ({
              title: k.title_name.toUpperCase(),
              meta: k,
              value: data[k.name] || 0,
              color: k.color
            })).filter(v => v.value > 0)}
            style={{ height: '150px'}}
            startAngle={-180}
            lineWidth={30}
            paddingAngle={4}
            radius={35}
            labelPosition={115}
            label={({ dataEntry }) => dataEntry.title}
            labelStyle={(segmentIndex) => ({
              fontFamily: "Futura Medium",
              fill: (dataCategories || nervousSystemStates).map(k => ({name: k.name, color: k.color, value: data[k.name] || 0})).filter(obj => obj.value > 0)[segmentIndex].color,
              fontSize: "9px",
            })}
            children={
              <svg className="neurofit-ring-inner-image" x="35" y="35" width="30" height="30" viewBox="0 0 850 850" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Group-21" transform="translate(-87.000000, -87.000000)"><g id="Group-20" transform="translate(87.000000, 87.000000)"><rect id="Rectangle" style={{transition: "fill 200ms ease-out"}} fill={"#EDEEF2"} x="0" y="0" width="850" height="850" rx="425"></rect><g id="noun-pulse-1295069" transform="translate(10.130432, 77.301946)" fill={"#CFD2DD"}><g id="Group-17" transform="translate(105.919149, 0.000000)"><path d="M38.3255468,468.449367 L20.0921777,468.365331 C9.04660006,468.314422 0.0511207811,477.227363 0.000212419534,488.272941 C7.08066994e-05,488.303666 3.54895082e-15,488.334392 0,488.365118 L0,495.904327 C-5.52037192e-14,506.931138 8.92485376,515.877601 19.9516326,515.904268 L77.3808325,516.043154 C95.5090458,516.086995 111.514152,504.220484 116.739698,486.86169 L187.849104,250.642667 C189.441087,245.354242 195.01876,242.357684 200.307184,243.949668 C203.637132,244.952087 206.207195,247.612493 207.094019,250.975072 L289.999632,565.329178 C295.633235,586.690171 317.516679,599.439739 338.877672,593.806136 C352.100546,590.318826 362.62555,580.31813 366.783404,567.290544 L462.152751,268.474729 C465.328111,258.525539 474.57289,251.771873 485.016514,251.771873 L603.932401,251.771873 L603.932401,251.771873 L603.932401,195.482501 L457.179995,195.482501 C435.926318,195.482501 417.095915,209.183984 410.556817,229.406718 L338.381476,452.615288 C336.682266,457.870241 331.044804,460.752741 325.789851,459.053532 C322.49805,457.989116 319.99026,455.298855 319.159288,451.940519 L241.142011,136.637332 C235.835832,115.192659 214.149983,102.109825 192.70531,107.416003 C179.250516,110.7452 168.478176,120.802533 164.234195,133.997368 L62.2400196,451.104414 C58.9023752,461.481384 49.2259537,468.499607 38.3255468,468.449367 Z" id="Path" fillRule="nonzero"></path><path d="M577.574761,167.717627 L631.219029,213.822343 C640.014824,221.381914 641.016982,234.640558 633.457411,243.436354 C632.459643,244.597289 631.337927,245.645646 630.112262,246.562738 L576.467994,286.701499 C567.181769,293.649819 554.021069,291.754573 547.072749,282.468348 C544.355438,278.836743 542.886946,274.422974 542.886946,269.887301 L542.886946,183.643824 C542.886946,172.045844 552.288967,162.643824 563.886946,162.643824 C568.909493,162.643824 573.76571,164.443928 577.574761,167.717627 Z" id="Triangle"></path></g><path d="M0,468.272727 L126.68676,468.272727 C137.732455,468.272727 146.68676,477.227032 146.68676,488.272727 L146.68676,496.181818 C146.68676,507.227513 137.732455,516.181818 126.68676,516.181818 L21.2187705,516.181818 L21.2187705,516.181818 L0,468.272727 Z" id="Rectangle"></path></g></g></g></g></svg>
            }
          >
          </PieChart>
        </div>
        <div style={{fontFamily: "Futura Light", fontSize: "min(4vw, 18px)", marginTop: "max(1vw, 6px)"}}>
          {insightText || insightTextFunction(data, firstName)}
          {(!!(onLearnMoreButtonClick)) && (
            <span onClick={() => onLearnMoreButtonClick()} style={{display: "inline-block", padding: "0px 0.2em", cursor: "pointer"}}>
              <InfoSvg
                color={"#000000"}
                size={"min(3vw, 12px)"}
                backgroundColor={"#EDEEF2"}
              />
            </span>
          )}
        </div>
      </div>
    ) : (
      <div style={{fontFamily: "Futura Book", fontSize: "min(7vw, 32px)", marginTop: "max(1vw, 6px)", color: "#000000"}}>
        {"PENDING..."}
      </div>
    )}
  </div>
)


export default PieChartInsightSection